import { BaseApi } from '@core/api';
import type { LicensingStatus } from '@core/models/organization';
import { useQuery } from '@tanstack/react-query';

export type LicensingScope =
  | { account: string | undefined; org?: never }
  | { org: string | undefined; account?: never };

const FIFTEEN_MINUTES = 15 * 60 * 1000;

export function licensingQueryKey({ account, org }: Pick<LicensingScope, 'account' | 'org'>) {
  return ['licensing', { account, org }] as const;
}

export function useLicensing({
  account,
  org,
  enabled = true,
}: LicensingScope & { enabled?: boolean }) {
  return useQuery({
    queryKey: licensingQueryKey({ account, org }),
    queryFn: async () => {
      const { data } = await BaseApi.get<LicensingStatus>('/licensing/status', {
        params: account ? { account } : { org },
      });
      return data;
    },
    enabled: enabled && Boolean(account || org),
    staleTime: FIFTEEN_MINUTES,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
}
